<template>
    <div class="SelectTre">
        <el-select
            ref="elSelect"
            v-model="newVal"
            :placeholder="placeholder"
            filterable
            :filter-method="filterTree"
            clearable 
            popper-class="selectTree"
            :disabled="disabled"
            @clear="clear"
            popper-append-to-body
        >
            <el-option :value="newVal" :label="label" class="hasTree" disabled>
                <el-tree
                    :key="treeKey"
                    :data="list"
                    ref="tree"
                    :node-key="treeprops.value"
                    :props="treeprops"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                    :current-node-key="currentNodeKey"
                    :default-expand-all="true"
                    highlight-current
                    :check-strictly="true"
                    check-on-click-node
                    auto-expand-parent
                    @node-click="handleNodeClick"
                ></el-tree>
            </el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    name: 'ElSelectTree',
    props: {
        value: {
            type: [String, Number],
            require: true,
        },
        checkStrictly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        list: {
            // 树状列表:{label:'',value:'',children:[]}
            type: Array,
            default: () => [],
        },
        treeprops: {
            // 树状列表:{label:'',value:'',children:[]}
            type: Object,
            default: () => ({}),
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
    },

    data() {
        return {
            newVal: '', // 本页面选中的数据
            label: '',
            selectTree: {},
            defaultExpandedKeys: [], // 默认展开
            searchData: [], // 带搜索数据
            openSearch: false, // 是否开启搜索
            treeKey: 0, // 用于强制重新渲染树
        };
    },

    computed: {
        currentNodeKey() {
            return this.newVal === '' || this.newVal == null ? null : this.newVal;
        },
    },

    watch: {
        value: {
            handler(value) {
                this.newVal = value;

                if (value) {
                    this.defaultExpandedKeys = [value];
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(value); // 设置默认选择
                    });
                    const check = this.findLabel(this.list, value);
                    // console.log('selectTree',value,check,check[this.treeprops.label])
                    if (check) {
                        this.label = check[this.treeprops.label] || check.name;
                    }
                } else {
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(null); // 清空选中
                    });
                    this.label = '';
                }
            },
            deep: true, // 深度监听
            immediate: true, // 首次触发
        },
        newVal(value) {
            const check = this.findLabel(this.list, value);
            if (check) {
                this.label = check[this.treeprops.label] || check.name;
            }
            this.$emit('input', value);
        },
    },
    created() {
        // el-select 中加了filterable 点击箭头回收不去问题
        Object.getPrototypeOf(this.$options.components).ElSelect.options.methods.handleFocus = () => {};
    },
    mounted() {},
    methods: {
        // 节点选择事件
        handleNodeClick(data) {
            if (!data.children) {
                this.newVal = data[this.treeprops.value];
                this.label = data[this.treeprops.label];
                this.$refs.elSelect.blur();
                this.searchData = [];
                this.openSearch = false;
                this.$emit('change', data);
            }
        },
        // 筛选树
        async filterTree(value) {
            if (value) {
                this.openSearch = true;
                this.searchData = [];
                await this.findItem(this.list, value);
            } else {
                this.openSearch = false;
                this.searchData = [];
            }
        },
        // 递归筛选,查询时用
        findItem(arr, value) {
            return new Promise((resolve) => {
                for (let i = 0; i < arr.length; i++) {
                    const item = arr[i];
                    if (item.label.includes(value)) {
                        this.searchData.push(item);
                    } else if (item.children && item.children.length > 0) {
                        this.findItem(item.children, value);
                    }
                }
                resolve(true);
            });
        },
        // 递归筛选，回显label
        findLabel(arr, value) {
            let result = null;
            for (let i = 0; i < arr.length; i++) {
                const item = arr[i];
                if (item.id === value || item.deptId === value) {
                    result = item;
                    return result;
                } else if (item.children && item.children.length > 0) {
                    result = this.findLabel(item.children, value);
                    if (result) {
                        return result;
                    }
                }
            }
            return result;
        },
        // 清空事件
        clear() {
            this.label = '';
            this.newVal = '';
            this.searchData = [];
            this.openSearch = false;
            this.treeKey++;
            this.$nextTick(() => {
                if (this.$refs.tree) {
                    this.$refs.tree.setCurrentKey(null);
                }
            });
            this.$emit('change', null);
            this.$emit('input', null);
        },
    },
};
</script>
<style scoped lang="scss">
.SelectTre {
    display: inline-block;
    width: 100%;
}
.el-select {
    width: 100%;
}
.hasTree {
    padding: 0 !important;
    margin: 0;
    overflow: auto;
    line-height: normal;
    height: auto;
    background: rgba(7, 17, 80, 0.75);
    box-shadow: inset 0px 0px 10px 0px #49f0fd;
    opacity: 1;
    border: 1px solid #49f0fd;
    cursor: default !important;
    font-weight: 500 !important;
    ::v-deep .el-tree-node__content {
        height: 34px;
        line-height: 34px;
        color: #fff;
        background-color: #071150;
    }
    ::v-deep .el-tree-node__content:hover {
        background-color: #071150 !important;
    }
    ::v-deep .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        color: #49f0fd !important;
        background: linear-gradient(
            270deg,
            rgba(73, 240, 253, 0) 0%,
            rgba(73, 240, 253, 0.4) 32%,
            rgba(73, 240, 253, 0.4) 66%,
            rgba(73, 240, 253, 0) 100%
        );
    }
    ::v-deep .el-tree-node__label {
        font-size: 14px !important;
    }
    ::v-deep .el-tree{
        color: #49f0fd !important;
        background: linear-gradient(
            270deg,
            rgba(73, 240, 253, 0) 0%,
            rgba(73, 240, 253, 0.4) 32%,
            rgba(73, 240, 253, 0.4) 66%,
            rgba(73, 240, 253, 0) 100%
        );
    }
}
</style>
